export const FETCH_ASSIGNED_USERS_REQUEST = 'FETCH_ASSIGNED_USERS_REQUEST'
export const FETCH_ASSIGNED_USERS_SUCCESS = 'FETCH_ASSIGNED_USERS_SUCCESS'
export const FETCH_ASSIGNED_USERS_FAILURE = 'FETCH_ASSIGNED_USERS_FAILURE'
